<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <!-- BUSCAR PEDIDO PELO NÚMERO DO PEDIDO -->
        <div class="input-group float-end align-items-center w-38">
          <input type="text" class="form-control sombra" [(ngModel)]="inputBusca" (keyup.enter)="buscaNoticiaConteudo()"
            placeholder="Buscar notícia">
          <button class="btn-icon" (click)="buscaNoticiaConteudo()">
            <i class="fa fa-search c-primary icone-lupa" aria-hidden="true"></i>
          </button>
        </div>
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Informativo Alelo</h1>
        <p class="paragrafo mb-4">Fique sabendo de todas as novidades relacionadas à Gestão de Vale-Transporte e
        Mobilidade</p>

        @if (inputBusca && inputFiltrado) {
          <div class="row mb-3 mt-1">
            <div class="col-12">
              <button class="botao-noticia ativo text-start" (click)="removerTodosFiltros()">{{inputBusca}}
                <span class="ms-2 float-end">X</span>
              </button>
            </div>
          </div>
        }

        <div class="news-header mb-4 mt-1">
          <button class="botao-noticia ativo me-3" [ngClass]="{ 'ativo': semFiltro }" (click)="removerTodosFiltros()">
            Informações em geral
          </button>
          <button class="botao-noticia me-3" [ngClass]="{ 'ativo': filtroReajuste }" (click)="filtrarReajuste()"
            id="botaoReajuste">Reajuste de tarifa
          </button>
          <button class="botao-noticia me-3" [ngClass]="{ 'ativo': filtroMigracao}" (click)="filtrarMigracao()"
            id="botaoMigracao">Migrações de operadoras
          </button>
          @if (!filtrarData) {
            <button class="botao-noticia me-3" (click)="filtrarData = true" id="botaoData">Por data
            </button>
          }

          @if (filtrarData) {
            <div class="dataPicker">
              <div class="datepicker-wrapper">
                <input
                  class="form-control"
                  [(ngModel)]="dataFiltrada"
                  [ngClass]="{ 'ativo': filtrarData && !semFiltro }"
                  placeholder="dd/mm/aaaa"
                  dateMask
                  [matDatepicker]="picker3"
                  >
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
              </div>
            </div>
          }

          @if (filtrarData) {
            <button class="botao-outline ms-3" (click)="filtrarPorData()"
              [ngClass]="{ 'disabled': !dataFiltrada}" [disabled]="!dataFiltrada">FILTRAR
            </button>
          }
          @if (filtrarData) {
            <button class="botao-outline ms-3" (click)="removerTodosFiltros()">Limpar filtro</button>
          }
        </div>

        @if (noticias && noticias.data) {
          <div>
            <div class="row">
              @for (noticia of noticias.data | paginate: { id: 'paginacaoNoticias',
                itemsPerPage: noticiasPorPagina,
                currentPage: paginaNoticia,
                totalItems: $safeNavigationMigration(noticias?.length) }; track noticia) {
                <div class="col-4 pe-5 mb-5">
                  <h4 class="titulo-noticia">{{noticia.resumoNoticia}}</h4>
                  <p class="descricao-noticia">{{noticia.descAssuntoNoticia}}</p>

                  <div class="news-content">
                    <span class="data-noticia"><i class="fa fa-calendar me-2"
                    aria-hidden="true"></i>{{noticia.dataDaNoticia | appDate: 'dd/MM/yyyy'}}</span>
                    <button class="veja-mais-noticia btn-icon" (click)="detalharNoticias(noticia.idNoticia)">Veja mais</button>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- FOOTER-CARD - PAGINAÇÃO -->
        <!-- FOOTER-CARD - PAGINAÇÃO - EMPRESAS -->
        @if (noticias && noticias.data?.length) {
          <div class="footer-card">
            <div>
              <app-select
                [value]="noticiasPorPagina"
                (valueChanges)="noticiasPorPagina = $event"
                name="noticiasPorPaginaName"
              [options]="[
                        {name : 'Exibir 3 por página' , value : '3'} ,
                        {name : 'Exibir 6 por página' , value : '6'} ,
                        {name : 'Exibir 9 por página' , value : '9'}

                        ]"
                optionValue="value"
                optionText="name">
              </app-select>
            </div>
            <!-- Paginação CENTRAL -->
            <div>
              <pagination-controls class="my-pagination" id="paginacaoNoticias" directionLink="true"
                (pageChange)="paginaNoticia = $event" responsive="true" previousLabel="Anterior"
              nextLabel="Próxima"></pagination-controls>
            </div>
            <div>
              <p><span class="itens-pagina">{{noticias.data.length}}</span> Registros foram encontrados</p>
            </div>
          </div>
        }

        <!-- CARREGAMENTO NOTICIAS -->
        @if (noticias === null) {
          <div>
            <div class="text-center">
              <output class="spinner-border c-primary">
                <span class="visually-hidden">Consultando notícias ...</span>
              </output>
            </div>
            <p class="legenda-spinner">Consultando notícias ...</p>
          </div>
        }

        <!-- CASO DE ERRO NOTICIAS -->
        @if (noticias === false) {
          <div class="text-center">
            <img src="/assets/img/erro.png" alt="representando erro na consulta das notícias" width="230px">
            <p class="legenda-erro">Ocorreu um erro na consulta das noticias.</p>
          </div>
        }

        <!-- CASO NÃO TENHA NOTICIAS RELACIONADAS -->
        <!-- EMPRESA NÃO POSSUI PEDIDOS -->
        @if (!noticias?.data?.length) {
          <div class="text-center">
            <img src="/assets/img/vazio.png" alt="representando que nenhuma notícia foi encontrada" width="230px">
            <p class="legenda-vazio">Nenhuma notícia encontrada.</p>
          </div>
        }

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
